import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import api, { BASE_URL } from "../../Utils/api";
import { Salvar, Cancelar } from "../Generals/buttons";


const ClassificacaoTiposDocumentoModal = ({ show, handleClose, item, idEntidade, fetchLista }) => {
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [situacao, setSituacao] = useState("A");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (item) {
      setNome(item.nome || "");
      setDescricao(item.descricao || "");
      setSituacao(item.situacao || "A");
    } else {
      setNome("");
      setDescricao("");
      setSituacao("A");
    }
    setError("");
  }, [item, show]);

  const handleSave = async () => {
    const trimmedNome = String(nome || "").trim();
    if (!trimmedNome) {
      setError("Nome é obrigatório.");
      return;
    }
    if (!item && !idEntidade) {
      setError("Entidade não selecionada. Selecione uma entidade no sistema.");
      return;
    }
    setError("");
    setSaving(true);
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      };
      const payload = { nome: trimmedNome, descricao: descricao || null, situacao };
      let resultado = null;
      if (item) {
        await api.put(
          `${BASE_URL}/api/classificacaoTiposDocumento/EditarClassificacaoTiposDocumento/${item.id}`,
          payload,
          { headers }
        );
      } else {
        const res = await api.post(
          `${BASE_URL}/api/classificacaoTiposDocumento/InserirClassificacaoTiposDocumento/${idEntidade}`,
          payload,
          { headers }
        );
        resultado = res.data?.data || res.data || null;
      }
      fetchLista();
      handleClose(resultado);
    } catch (err) {
      const data = err.response?.data;
      const msg =
        (typeof data?.message === "string" && data.message) ||
        (typeof data?.error === "string" && data.error) ||
        (typeof data === "string" && data) ||
        err.message ||
        "Erro ao salvar. Tente novamente.";
      setError(msg);
      if (err.response?.status === 409) {
        return;
      }
      if (err.response?.status) {
        console.error("[ClassificacaoTiposDocumento] Erro ao salvar:", err.response.status, data);
      } else {
        console.error("[ClassificacaoTiposDocumento] Erro de rede ou servidor:", err);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" dialogClassName="modal-dialog-top">
      <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          {item ? "Editar Classificação" : "Nova Classificação"}
          {item?.nome && (
            <span style={{ display: "block", fontSize: "0.82rem", fontWeight: 400, color: "var(--text-muted)", marginTop: 2 }}>
              {item.nome}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        <Form>
          <Form.Group className="mb-3" controlId="nome">
            <Form.Label>Nome *</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              maxLength={100}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="descricao">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              as="textarea"
              placeholder="Descrição"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              rows={3}
              maxLength={255}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="situacao">
            <Form.Label>Situação</Form.Label>
            <Form.Select value={situacao} onChange={(e) => setSituacao(e.target.value)}>
              <option value="A">Ativo</option>
              <option value="I">Inativo</option>
            </Form.Select>
          </Form.Group>
          {error && <div className="text-danger small mb-2">{error}</div>}
        </Form>
      </Modal.Body>
      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-esquerda" />
        <div className="modal-footer-acoes-direita">
          <Cancelar onClick={handleClose} disabled={saving} />
          <Salvar onClick={handleSave} loading={saving} />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ClassificacaoTiposDocumentoModal;
